import React from "react";
import './ConnectWallet.css';
import API from '../API';
import { useAuth0 } from "@auth0/auth0-react";
import NamiIcon from './images/nami_icon.png';
import EternlIcon from './images/eternl_icon.png';
import MetamaskIcon from './images/metamask_icon.png';
import NiftyGatewayIcon from './images/nifty_gateway_icon.png';

const ConnectWallet = ({ callback, setWallets }) => {
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    async function signEternl() {
        if (!window.cardano || !window.cardano.eternl) {
            window.open("https://eternl.io/", '_blank');
            return
        }

        if (!isAuthenticated) {
            console.error("Not authenticated, cannot add wallet.");
        }

        const api = await window.cardano.eternl.enable();

        // Get the wallet
        var addresses = await api.getUnusedAddresses();
        if (!addresses.length) {
            console.log("No wallets found.");
            return;
        }
        var address = addresses[0];

        // Sign
        try {
            var coseSign = await api.signData(address, "By signing this note, I verify that I am the owner of this wallet. I agree to share my public wallet address with Future Fest and connect it with my Future Fest account so I can use my NFTs in-game.");
        } catch (error) {
            console.log("error: ");
            console.log(error);
            return;
        }

        const accessToken = await getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: "ffclient:play",
          });
        const response = await API.addWallet(accessToken, { cose: coseSign, wallet: "eternl" });
        if (response.status !== 200) {
            alert("Sorry, there was an issue adding this wallet. Please let the devs know on discord.");
            return;
        }

        const data = await response.json();
        setWallets(data.wallets);
        callback();
    };

    async function signNami() {
        if (!window.cardano || !window.cardano.nami) {
            window.open("https://namiwallet.io/", '_blank');
            return
        }

        if (!isAuthenticated) {
            console.error("Not authenticated, cannot add wallet.");
        }

        // Forward-compatibility shim.
        if (window.cardano && !window.cardano.nami) { // Better way?
            window.cardano.nami = window.cardano; // Test this
        }

        // Make sure nami is enabled.
        const api = await window.cardano.nami.enable();

        // Get the wallet.
        var addresses = await api.getUsedAddresses();
        if (!addresses.length) {
            console.log("No wallets found.");
            return;
        }
        var address = addresses[0];

        // Sign
        var hex = new Buffer.from("By signing this note, I verify that I am the owner of this wallet. I agree to share my public wallet address with Future Fest and connect it with my Future Fest account so I can use my NFTs in-game.").toString('hex');
        try {
            var coseSign = await api.signData(address, hex);
        } catch (error) {
            console.log("error: ");
            console.log(error);
            return;
        }

        const accessToken = await getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: "ffclient:play",
          });
        const response = await API.addWallet(accessToken, { cose: coseSign, wallet: "nami" });
        if (response.status !== 200) {
            alert("Sorry, there was an issue adding this wallet. Please let the devs know on discord.");
            return;
        }

        const data = await response.json();
        setWallets(data.wallets);
        callback();
    };

    async function signMetamask() {
        if (typeof window.ethereum === 'undefined') {
            window.open("https://metamask.io/", '_blank');
            return;
        }

        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            const from = accounts[0];
            const message = 'By signing this note, I verify that I am the owner of this wallet. I agree to share my public wallet address with Future Fest and connect it with my Future Fest account so I can use my NFTs in-game.';
            const msg = `0x${Buffer.from(message, 'utf8').toString('hex')}`;
            const sign = await window.ethereum.request({
                method: 'personal_sign',
                params: [msg, from, 'Example password'],
            });

            const accessToken = await getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                scope: "ffclient:play",
              });
            const response = await API.addEthWallet(accessToken, { signature: sign, wallet: "metamask" });
            if (response.status !== 200) {
                alert("Sorry, there was an issue adding this wallet. Please let the devs know on discord.");
                return;
            }
    
            const data = await response.json();
            setWallets(data.wallets);
        } catch (error) {
            console.error(error);
            return;
        }

        callback();
    };

    async function signNiftyGateway() {
        window.open("https://niftygateway.com/authorize?scope=profile:read&client_id=qp4e6471lbgZiaKhNGWfufqB7br4c4u7pNoAE2Ok&redirect_uri=" + window.origin + "&response_type=code", '_self');
        callback();
    };

    return (
        <div>
            <h2 className="connect-wallet-title">Connect your wallet</h2>
            <h3 className="connect-wallet-subtitle">Connect with one of our available wallet providers or create a new one.</h3>
            <ul className="wallet-name">
                <li><button className="wallet-add-button" onClick={signNami}><img src={NamiIcon} alt="Nami wallet icon" />&nbsp;&nbsp;Nami Wallet</button></li>
                <li><button className="wallet-add-button" onClick={signEternl}><img src={EternlIcon} alt="Eternl wallet icon" />&nbsp;&nbsp;Eternl</button></li>
                <li><button className="wallet-add-button" onClick={signMetamask}><img src={MetamaskIcon} alt="Metamask wallet icon" />&nbsp;&nbsp;Metamask</button></li>
                <li><button className="wallet-add-button" onClick={signNiftyGateway}><img src={NiftyGatewayIcon} alt="Nifty Gateway wallet icon" />&nbsp;&nbsp;Nifty Gateway</button></li>
            </ul>
            <h5 className="connect-wallet-footnote">New to Cardano?<br/><a href="https://youtu.be/dpfjKtLrucg" target="_blank" rel="noopener noreferrer">Learn more about wallets</a></h5>
        </div>
    );
};

export default ConnectWallet;
